import { render, staticRenderFns } from "./Brewer.vue?vue&type=template&id=25b0962f&"
import script from "./Brewer.vue?vue&type=script&lang=js&"
export * from "./Brewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports